// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RT2 Test Cases Modal — flat enterprise surface
   Prefer mounting inside [data-rt-shell-main] so the sidebar stays visible.
   Body-portaled fallback reserves sidebar width via --rt-shell-sidebar-offset. */

.test-cases-modal-overlay {
  position: fixed;
  top: var(--rt-topbar-h, var(--topbar-height, 56px));
  left: var(--rt-shell-sidebar-offset, var(--rt-sidebar-collapsed, 68px));
  right: 0;
  bottom: 0;
  z-index: 25;
  display: flex;
  flex-direction: column;
  background: var(--bg-primary, #f7f9fc);
  color: var(--text-primary);
  transition: left 180ms ease;
}

/* Inside AppShell main: fill only the content column (sidebar stays put). */
[data-rt-shell-main] > .test-cases-modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  transition: none;
}

@media (max-width: 1024px) {
  .test-cases-modal-overlay {
    left: 0;
  }
}

.test-cases-modal-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  background: transparent;
}

.test-cases-modal-container > .back-btn {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  margin: 14px 20px 0;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text-primary);
  font: inherit;
  font-size: 0.8125rem;
  font-weight: 550;
  cursor: pointer;
  box-shadow: none;
}

.test-cases-modal-container > .back-btn:hover {
  background: var(--surface-hover);
}

.test-cases-modal-content {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 14px 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: transparent;
}

.test-cases-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 20px;
  padding: 12px 14px;
  margin: 0;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: none;
}

.test-cases-summary p {
  margin: 0;
  font-size: 0.8125rem;
  color: var(--text-secondary);
  background: transparent;
  box-shadow: none;
}

.test-cases-summary p strong {
  color: var(--text-primary);
  font-weight: 650;
  background: transparent;
  box-shadow: none;
}

.test-cases-summary .regenerate-btn {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--primary);
  font: inherit;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: none;
}

.test-cases-summary .regenerate-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--primary) 8%, var(--surface));
}

.test-cases-summary .regenerate-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* Test case cards */
.test-case-item,
.scenario-test-cases {
  margin: 0;
  padding: 16px 18px;
  background: var(--surface) !important;
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: none;
  color: var(--text-primary) !important;
  transition: border-color 140ms ease, background 140ms ease;
}

.test-case-item:hover,
.scenario-test-cases:hover {
  background: var(--surface-hover) !important;
  box-shadow: none;
  transform: none;
  border-color: color-mix(in srgb, var(--primary) 28%, var(--border));
  color: var(--text-primary) !important;
}

.test-case-item:hover h3,
.test-case-item:hover h4,
.test-case-item:hover h5,
.test-case-item:hover h6,
.scenario-test-cases:hover h3,
.scenario-test-cases:hover h4,
.test-case-item:hover .test-case-desc,
.test-case-item:hover .test-case-meta p,
.test-case-item:hover .test-case-details li,
.test-case-item:hover .test-case-details p {
  color: var(--text-primary) !important;
  background: transparent !important;
  box-shadow: none !important;
  border-color: transparent !important;
  text-shadow: none !important;
}

.test-case-item:hover .test-case-meta p strong,
.test-case-item:hover .test-case-details h4,
.test-case-item:hover .test-case-details h6 {
  color: var(--text-muted) !important;
  background: transparent !important;
}

.test-case-item h3,
.scenario-test-cases h3,
.test-case-item h5 {
  margin: 0 0 10px;
  padding: 0;
  border: none;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--text-primary);
  background: transparent;
  box-shadow: none;
  text-shadow: none;
}

.scenario-test-cases h3 {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.scenario-test-cases h3::after,
.test-case-item h3::after,
.test-case-item h5::after {
  content: '▾';
  margin-left: auto;
  opacity: 0.45;
  font-size: 0.75rem;
  transition: transform 0.2s ease;
}

.scenario-test-cases.open h3::after,
.test-case-item.open h3::after,
.test-case-item.open h5::after {
  transform: rotate(180deg);
}

.test-case-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin: 0 0 12px;
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
}

.test-case-meta p {
  margin: 0;
  font-size: 0.8125rem;
  color: var(--text-secondary);
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

.test-case-meta p strong {
  color: var(--text-muted);
  font-weight: 600;
  background: transparent !important;
}

.test-case-item > p,
.test-case-item .test-case-desc {
  margin: 0 0 14px;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--text-secondary);
  background: transparent !important;
  box-shadow: none !important;
}

.test-case-item > p strong {
  color: var(--text-muted);
  font-weight: 600;
  background: transparent !important;
}

/* Details: flat on the card — no nested gray panel */
.test-case-details,
.scenario-details {
  margin: 0;
  padding: 14px 0 0;
  border-top: 1px solid var(--border-subtle, var(--border));
  border-left: none;
  border-radius: 0;
  background: transparent !important;
  box-shadow: none !important;
}

.test-case-details h4,
.test-case-details h6,
.scenario-test-cases h4 {
  margin: 12px 0 6px;
  padding: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--text-muted);
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
  text-shadow: none !important;
}

.test-case-details h4:first-child,
.test-case-details h6:first-child {
  margin-top: 0;
}

.test-case-details ol,
.test-case-details ul {
  margin: 0;
  padding-left: 1.15rem;
  background: transparent !important;
}

.test-case-details li,
.scenario-details p {
  margin: 0 0 4px;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--text-primary);
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
  text-shadow: none !important;
}

.scenario-details p strong {
  background: transparent !important;
  color: var(--text-muted);
}

.test-cases-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: transparent;
}

.scenario-test-cases.collapsed .scenario-details,
.scenario-test-cases.collapsed .test-cases-list {
  display: none;
}

.test-case-item .test-case-meta,
.test-case-item .test-case-details {
  overflow: visible;
  max-height: none;
  opacity: 1;
  transform: none;
  pointer-events: auto;
}

.test-cases-modal-pagination {
  flex-shrink: 0;
  padding: 12px 20px;
  border-top: 1px solid var(--border);
  background: var(--surface);
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  gap: 12px;
  color: var(--text-secondary);
  background: transparent;
}

.no-test-cases {
  padding: 32px;
  text-align: center;
  color: var(--text-muted);
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.btn-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid color-mix(in srgb, var(--primary) 25%, transparent);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: rt-tc-spin 0.6s linear infinite;
}

@keyframes rt-tc-spin {
  to { transform: rotate(360deg); }
}

/* Dark mode: never bleach cards on hover */
[data-theme='dark'] .test-case-item,
[data-theme='dark'] .scenario-test-cases {
  background: var(--surface) !important;
  color: var(--text-primary) !important;
}

[data-theme='dark'] .test-case-item:hover,
[data-theme='dark'] .scenario-test-cases:hover {
  background: var(--surface-hover) !important;
  color: var(--text-primary) !important;
}

[data-theme='dark'] .test-case-item:hover .test-case-details,
[data-theme='dark'] .test-case-item:hover .test-case-meta,
[data-theme='dark'] .test-case-item:hover .test-case-details li,
[data-theme='dark'] .test-case-item:hover .test-case-details ul,
[data-theme='dark'] .test-case-item:hover .test-case-details ol,
[data-theme='dark'] .test-case-item:hover .test-case-details h4,
[data-theme='dark'] .test-case-item:hover .test-case-details h6,
[data-theme='dark'] .test-case-item:hover p,
[data-theme='dark'] .test-case-item:hover strong {
  background: transparent !important;
  box-shadow: none !important;
  text-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/test-cases-modal.css"],"names":[],"mappings":"AAAA;;iFAEiF;;AAEjF;EACE,eAAe;EACf,mDAAmD;EACnD,uEAAuE;EACvE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,OAAO;EACT;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;EAC1B,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,4BAA4B;EAC5B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,qBAAqB;EACrB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;;EAEE,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,0DAA0D;AAC5D;;AAEA;;EAEE,2CAA2C;EAC3C,gBAAgB;EAChB,eAAe;EACf,mEAAmE;EACnE,qCAAqC;AACvC;;AAEA;;;;;;;;;;EAUE,qCAAqC;EACrC,kCAAkC;EAClC,2BAA2B;EAC3B,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;;;EAGE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;EAGE,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,4BAA4B;EAC5B,kCAAkC;EAClC,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,qDAAqD;AACrD;;EAEE,SAAS;EACT,iBAAiB;EACjB,yDAAyD;EACzD,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;;EAGE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kCAAkC;EAClC,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,SAAS;EACT,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;EAClC,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qEAAqE;EACrE,gCAAgC;EAChC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,2CAA2C;AAC3C;;EAEE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;;EAEE,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;;;;;;;;;EASE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B","sourcesContent":["/* RT2 Test Cases Modal — flat enterprise surface\n   Prefer mounting inside [data-rt-shell-main] so the sidebar stays visible.\n   Body-portaled fallback reserves sidebar width via --rt-shell-sidebar-offset. */\n\n.test-cases-modal-overlay {\n  position: fixed;\n  top: var(--rt-topbar-h, var(--topbar-height, 56px));\n  left: var(--rt-shell-sidebar-offset, var(--rt-sidebar-collapsed, 68px));\n  right: 0;\n  bottom: 0;\n  z-index: 25;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-primary, #f7f9fc);\n  color: var(--text-primary);\n  transition: left 180ms ease;\n}\n\n/* Inside AppShell main: fill only the content column (sidebar stays put). */\n[data-rt-shell-main] > .test-cases-modal-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 20;\n  transition: none;\n}\n\n@media (max-width: 1024px) {\n  .test-cases-modal-overlay {\n    left: 0;\n  }\n}\n\n.test-cases-modal-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n  background: transparent;\n}\n\n.test-cases-modal-container > .back-btn {\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 34px;\n  margin: 14px 20px 0;\n  padding: 0 12px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n  color: var(--text-primary);\n  font: inherit;\n  font-size: 0.8125rem;\n  font-weight: 550;\n  cursor: pointer;\n  box-shadow: none;\n}\n\n.test-cases-modal-container > .back-btn:hover {\n  background: var(--surface-hover);\n}\n\n.test-cases-modal-content {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 14px 20px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  background: transparent;\n}\n\n.test-cases-summary {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px 20px;\n  padding: 12px 14px;\n  margin: 0;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  box-shadow: none;\n}\n\n.test-cases-summary p {\n  margin: 0;\n  font-size: 0.8125rem;\n  color: var(--text-secondary);\n  background: transparent;\n  box-shadow: none;\n}\n\n.test-cases-summary p strong {\n  color: var(--text-primary);\n  font-weight: 650;\n  background: transparent;\n  box-shadow: none;\n}\n\n.test-cases-summary .regenerate-btn {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n  color: var(--primary);\n  font: inherit;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: none;\n}\n\n.test-cases-summary .regenerate-btn:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--primary) 8%, var(--surface));\n}\n\n.test-cases-summary .regenerate-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* Test case cards */\n.test-case-item,\n.scenario-test-cases {\n  margin: 0;\n  padding: 16px 18px;\n  background: var(--surface) !important;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  box-shadow: none;\n  color: var(--text-primary) !important;\n  transition: border-color 140ms ease, background 140ms ease;\n}\n\n.test-case-item:hover,\n.scenario-test-cases:hover {\n  background: var(--surface-hover) !important;\n  box-shadow: none;\n  transform: none;\n  border-color: color-mix(in srgb, var(--primary) 28%, var(--border));\n  color: var(--text-primary) !important;\n}\n\n.test-case-item:hover h3,\n.test-case-item:hover h4,\n.test-case-item:hover h5,\n.test-case-item:hover h6,\n.scenario-test-cases:hover h3,\n.scenario-test-cases:hover h4,\n.test-case-item:hover .test-case-desc,\n.test-case-item:hover .test-case-meta p,\n.test-case-item:hover .test-case-details li,\n.test-case-item:hover .test-case-details p {\n  color: var(--text-primary) !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  border-color: transparent !important;\n  text-shadow: none !important;\n}\n\n.test-case-item:hover .test-case-meta p strong,\n.test-case-item:hover .test-case-details h4,\n.test-case-item:hover .test-case-details h6 {\n  color: var(--text-muted) !important;\n  background: transparent !important;\n}\n\n.test-case-item h3,\n.scenario-test-cases h3,\n.test-case-item h5 {\n  margin: 0 0 10px;\n  padding: 0;\n  border: none;\n  font-size: 1rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--text-primary);\n  background: transparent;\n  box-shadow: none;\n  text-shadow: none;\n}\n\n.scenario-test-cases h3 {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.scenario-test-cases h3::after,\n.test-case-item h3::after,\n.test-case-item h5::after {\n  content: '▾';\n  margin-left: auto;\n  opacity: 0.45;\n  font-size: 0.75rem;\n  transition: transform 0.2s ease;\n}\n\n.scenario-test-cases.open h3::after,\n.test-case-item.open h3::after,\n.test-case-item.open h5::after {\n  transform: rotate(180deg);\n}\n\n.test-case-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 16px;\n  margin: 0 0 12px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n}\n\n.test-case-meta p {\n  margin: 0;\n  font-size: 0.8125rem;\n  color: var(--text-secondary);\n  background: transparent !important;\n  box-shadow: none !important;\n  border: none !important;\n}\n\n.test-case-meta p strong {\n  color: var(--text-muted);\n  font-weight: 600;\n  background: transparent !important;\n}\n\n.test-case-item > p,\n.test-case-item .test-case-desc {\n  margin: 0 0 14px;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.test-case-item > p strong {\n  color: var(--text-muted);\n  font-weight: 600;\n  background: transparent !important;\n}\n\n/* Details: flat on the card — no nested gray panel */\n.test-case-details,\n.scenario-details {\n  margin: 0;\n  padding: 14px 0 0;\n  border-top: 1px solid var(--border-subtle, var(--border));\n  border-left: none;\n  border-radius: 0;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.test-case-details h4,\n.test-case-details h6,\n.scenario-test-cases h4 {\n  margin: 12px 0 6px;\n  padding: 0;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  background: transparent !important;\n  box-shadow: none !important;\n  border: none !important;\n  text-shadow: none !important;\n}\n\n.test-case-details h4:first-child,\n.test-case-details h6:first-child {\n  margin-top: 0;\n}\n\n.test-case-details ol,\n.test-case-details ul {\n  margin: 0;\n  padding-left: 1.15rem;\n  background: transparent !important;\n}\n\n.test-case-details li,\n.scenario-details p {\n  margin: 0 0 4px;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: var(--text-primary);\n  background: transparent !important;\n  box-shadow: none !important;\n  border: none !important;\n  text-shadow: none !important;\n}\n\n.scenario-details p strong {\n  background: transparent !important;\n  color: var(--text-muted);\n}\n\n.test-cases-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  background: transparent;\n}\n\n.scenario-test-cases.collapsed .scenario-details,\n.scenario-test-cases.collapsed .test-cases-list {\n  display: none;\n}\n\n.test-case-item .test-case-meta,\n.test-case-item .test-case-details {\n  overflow: visible;\n  max-height: none;\n  opacity: 1;\n  transform: none;\n  pointer-events: auto;\n}\n\n.test-cases-modal-pagination {\n  flex-shrink: 0;\n  padding: 12px 20px;\n  border-top: 1px solid var(--border);\n  background: var(--surface);\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px;\n  gap: 12px;\n  color: var(--text-secondary);\n  background: transparent;\n}\n\n.no-test-cases {\n  padding: 32px;\n  text-align: center;\n  color: var(--text-muted);\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n}\n\n.btn-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid color-mix(in srgb, var(--primary) 25%, transparent);\n  border-top-color: var(--primary);\n  border-radius: 50%;\n  animation: rt-tc-spin 0.6s linear infinite;\n}\n\n@keyframes rt-tc-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Dark mode: never bleach cards on hover */\n[data-theme='dark'] .test-case-item,\n[data-theme='dark'] .scenario-test-cases {\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n}\n\n[data-theme='dark'] .test-case-item:hover,\n[data-theme='dark'] .scenario-test-cases:hover {\n  background: var(--surface-hover) !important;\n  color: var(--text-primary) !important;\n}\n\n[data-theme='dark'] .test-case-item:hover .test-case-details,\n[data-theme='dark'] .test-case-item:hover .test-case-meta,\n[data-theme='dark'] .test-case-item:hover .test-case-details li,\n[data-theme='dark'] .test-case-item:hover .test-case-details ul,\n[data-theme='dark'] .test-case-item:hover .test-case-details ol,\n[data-theme='dark'] .test-case-item:hover .test-case-details h4,\n[data-theme='dark'] .test-case-item:hover .test-case-details h6,\n[data-theme='dark'] .test-case-item:hover p,\n[data-theme='dark'] .test-case-item:hover strong {\n  background: transparent !important;\n  box-shadow: none !important;\n  text-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
